import React, { useState, useEffect } from 'react';
import { getAvailableClients } from '../services/api';
import './ClientSelector.css';

/** Super-admin client picker. `list` shows every client (burger menu). Header uses a closed dropdown. */
const ClientSelector = ({ msalInstance, onClientChange, userData, selectedClientId: selectedFromParent, list = false }) => {
  const [clients, setClients] = useState([]);
  const [selectedClientId, setSelectedClientId] = useState(
    selectedFromParent ? String(selectedFromParent) : ''
  );
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setSelectedClientId(selectedFromParent ? String(selectedFromParent) : '');
  }, [selectedFromParent]);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        setLoading(true);
        const clientsData = await getAvailableClients(msalInstance);
        const normalized = (clientsData || []).map((c) => ({
          ...c,
          displayName: (c?.clientname || '').toUpperCase()
        }));
        setClients(normalized);
      } catch (err) {
        console.error('Failed to fetch clients:', err);
        setError('Failed to load client list');
      } finally {
        setLoading(false);
      }
    };

    if (userData?.is_super_admin) {
      fetchClients();
    } else {
      setLoading(false);
    }
  }, [msalInstance, userData]);

  const handleClientChange = (event) => {
    const clientId = event.target.value ? Number(event.target.value) : null;
    setSelectedClientId(event.target.value);
    const client = clients.find(c => c.id === clientId);
    if (onClientChange) onClientChange(clientId, client?.logo || null);
  };

  if (!userData?.is_super_admin) return null;

  if (loading) {
    return (
      <div className="client-selector">
        <span className="loading">Loading clients...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="client-selector">
        <span className="error">{error}</span>
      </div>
    );
  }

  const selectedName = clients.find(c => String(c.id) === String(selectedClientId))?.displayName;

  return (
    <div className="client-selector">
      {/* size keeps the client list in the menu so it can scroll */}
      <select
        id={list ? 'client-select-menu' : 'client-select'}
        size={list ? 6 : undefined}
        value={selectedClientId}
        onChange={handleClientChange}
        className="client-selector-dropdown"
        title="Select client to view orders for"
      >
        <option value="">Select a Client</option>
        {clients.map((client) => (
          <option key={client.id} value={client.id}>
            {client.displayName || client.clientname}
          </option>
        ))}
      </select>
      {selectedName && (
        <div className="impersonation-indicator">
          <i className="fas fa-eye"></i>
          <span>Viewing: <strong>{selectedName}</strong></span>
        </div>
      )}
    </div>
  );
};

export default ClientSelector;
